import z from "zod";

export const objectiveSystemsSchema = z.object({
  display_name: z
    .string({ message: 'Campo obrigatório' })
    .trim()
    .min(3, { message: 'Tamanho mínimo: 3 caracteres' }),
});

export type ObjectiveSystemsValidationSchema = z.infer<typeof objectiveSystemsSchema>;
